import React from "react";
import Downloads from "../components/Downloads";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/global.css";
import { Helmet } from "react-helmet-async";

const DownloadPage = () => {
  return (
    <>
      <Helmet>
        <title>Downloads | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Access a wide range of product brochures, manuals, and documentation on TimeWatch Infocom’s Downloads page. Get detailed information on our biometric solutions, access control systems, time attendance systems, and smart security technologies. Our downloadable resources include guides for entrance automation, parking management solutions, and more. Stay informed and explore the latest updates on our cutting-edge security products designed to meet the needs of businesses and organizations. Download the essential materials to understand our innovative security solutions better."
        />
        <link rel="canonical" href="https://www.timewatchindia.com/downloads" />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="download">
          <Downloads />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default DownloadPage;
